/**
 * Consolidated redux slice for authentication
 */
import { createSlice } from "@reduxjs/toolkit";
import { TokenManager } from "../../auth";
import { isFunction } from "lodash";

export const createAuthSlice = (config = {}) => {
  const {
    tokenRole = "member",
    extraReducers = {},
    initialState: customInitialState = {},
  } = config;

  const initialState = {
    token: null,
    user: { profile: {} },
    isAuthenticated: false,
    loading: false,
    error: null,
  };

  const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
      loginRequest: (state) => {
        state.loading = true;
        state.error = null;
      },
      loginSuccess: (state, action) => {
        console.log("Auth slice: loginSuccess action received", action.payload);
        state.token = action.payload.token;
        state.user = action.payload.user;
        state.isAuthenticated = true;
        state.loading = false;
        state.error = null;

        // Store token in storage
        TokenManager.setToken(action.payload.token);
      },
      loginFailure: (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
      },
      logout: (state) => {
        state.token = null;
        state.user = {};
        state.isAuthenticated = false;
        state.loading = false;
        state.error = null;
        // Token cookie is cleared by the caller (logoutUser / clearSession)
      },
    },
    extraReducers: (builder) => {
      // Handle user slice actions to keep state in sync
      builder
        .addCase("user/loginUserSuccess", (state, action) => {
          console.log("Auth slice handling user/loginSuccess", action.payload);
          state.token = action.payload.token;
          state.user = action.payload.user;
          state.isAuthenticated = true;
          state.loading = false;
          state.error = null;
        })
        .addCase("user/logoutUser", (state) => {
          console.log("Auth slice handling user/logout");
          state.token = null;
          state.user = {};
          state.isAuthenticated = false;
          state.loading = false;
          state.error = null;
        });

      // Add custom extra reducers
      if (isFunction(extraReducers)) {
        extraReducers(builder);
      }
    },
  });
  return authSlice;
};

export const authSlice = createAuthSlice();

export const { loginRequest, loginSuccess, loginFailure, logout } =
  authSlice.actions;
